import { render, staticRenderFns } from "./EntityRules.vue?vue&type=template&id=35f138ba"
import script from "./EntityRules.vue?vue&type=script&lang=js"
export * from "./EntityRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports